import React, { useEffect, useState, useRef } from "react";
import Box from "@mui/material/Box";

import { DataGrid, useGridApiRef } from "@mui/x-data-grid";
import addProduct from "../utils/addProducts.png";
import deleteIcon from "../utils/delete.png";
import Tooltip from "@mui/material/Tooltip";
import notAllowedSymbol from "../utils/notAllowedSymbol.svg";
import { AiOutlinePlus } from "react-icons/ai";
import AssignJobModalEntryForm from "./AssignJobModalEntryForm";

const OfficeJobsGrid = ({ productEntries, setProductEntries }) => {
  console.log("productEntries Initial", productEntries);
  const [selectedRows, setSelectedRows] = useState([]);
  const newSlNoRef = useRef({});
  const taskDescRefs = useRef({});
  const taskGroupRefs = useRef({});

  const [subJobAssignee, setSubJobAssignee] = useState(false);
  const [openAssignModel, setopenAssignModel] = useState(false);
  const [taskSerialToBeAassigned, setTaskSerialToBeAassigned] = useState(null);
  const [taskSerialFromSubjobGrid, setTaskSerialFromSubjobFrid] = useState(null);
 const [isInitialized, setIsInitialized] = useState(false);

  const [assignedTaskSerialsMap, setAssignedTaskSerialsMap] = useState({});



  const openAssign = (taskSerial) => {
    console.log("open assign model clicked ");
    setTaskSerialToBeAassigned(taskSerial);
    setopenAssignModel(true);
  };

  const handleAssignButtonLabel = (label,taskSerial) => {
    console.log('label',label)
    console.log('taskSerial',taskSerial)
    setTaskSerialFromSubjobFrid(taskSerial)
    // if (label === "Assign") setSubJobAssignee(true);
      if (label === "Assign") {
    setAssignedTaskSerialsMap((prev) => ({
      ...prev,
      [taskSerial]: true,
    }));
  }
  };



  const closeAssignModal = (e) => {
    // e.preventDefault();
    console.log("this assign modal is closed");
    setopenAssignModel(false);
  };

  const handleAssignPerson = (person) => {
    console.log("assignedPerson", person);
    setTimeout(() => {
      closeAssignModal();
    }, 600);
  };

  const toggleSelectAll = () => {
    if (selectedRows?.length === productEntries?.length) {
      setSelectedRows([]); // Unselect all if all are selected
    } else {
      setSelectedRows(productEntries?.map((_, index) => index)); // Select all rows
    }
  };

  // Toggle selection of a row
  const toggleRowSelection = (index) => {
    setSelectedRows(
      (prevSelectedRows) =>
        prevSelectedRows.includes(index)
          ? prevSelectedRows.filter((i) => i !== index) // Remove if already selected
          : [...prevSelectedRows, index] // Add if not selected
    );
  };

  // Delete selected rows
  const deleteSelectedRows = () => {
    const updatedEntries = productEntries.filter(
      (_, index) => !selectedRows.includes(index)
    );
    setProductEntries(updatedEntries);
    setSelectedRows([]); // Clear selection after deletion
  };

  const [currentProductEntryRowId, setCurrentProductEntryRowId] =
    useState(null);


 useEffect(() => {
    if (!isInitialized && (!productEntries || productEntries.length === 0)) {
      const initialRow = {
        id: Date.now(),
        Task_Serial: 1,
        Task_Description: "",
        task_group: "",
      };
      setProductEntries([initialRow]);
      setIsInitialized(true);
      
      // Focus on the first input after initialization
      setTimeout(() => {
        if (newSlNoRef.current[Date.now()]) {
          newSlNoRef.current[Date.now()].focus();
        }
      }, 100);
    } else if (!isInitialized) {
      setIsInitialized(true);
    }
  }, [productEntries, setProductEntries, isInitialized]);


  const handleAddRow = (e) => {
    e.preventDefault();

    // const nextId =
    //   productEntries?.length > 0
    //     ? Math.max(...productEntries?.map((r) => Number(r.id||0))) + 1
    //     : 1;
    const nextId =
      productEntries?.length > 0
        ? Math.max(...productEntries?.map((r) => Number(r?.Task_Serial || 0))) +
          1
        : 1;
    console.log("productEntries:", productEntries);

    const newRow = {
      // id: Number(nextId),
      id: Date.now(),
      Task_Serial: Number(nextId),
      Task_Description: "",
      task_group: "",
    };

    setProductEntries((prevEntries) => [...prevEntries, newRow]);

    setTimeout(() => {
      if (newSlNoRef.current[nextId]) {
        newSlNoRef.current[nextId].focus();
      }
    }, 0);

    setTimeout(() => {
      const newInput = taskDescRefs.current[nextId];
      if (newInput && newInput.focus) {
        newInput.focus();
      } else {
        console.warn("Ref not ready yet for row:", nextId);
      }
    }, 0);
  };

  // const handleInputChange = (id, field, value) => {
  //   console.log('inside handle input change')
  //   console.log("id f v", id, field, value);

  //   setCurrentProductEntryRowId(id);

  //   // Update the productEntries state with the new value
  //   let newArray = productEntries.map((item) => {
  //     if (item.id === id) {
  //       return {
  //         ...item,
  //         [field]: value,
  //       };
  //     }
  //     return item;
  //   });

  //   // Set the updated productEntries array to state
  //   setProductEntries(newArray);
  // };

  // const handleInputChange = (id, field, value) => {
  //   console.log("inside handle input change");
  //   console.log("id f v", id, field, value);

  //   setCurrentProductEntryRowId(id);

  //   // Update the productEntries state with the new value
  //   let newArray = productEntries.map((item) => {
  //     if (item.id === id) {
  //       return {
  //         ...item,
  //         [field]: value,
  //       };
  //     }
  //     return item;
  //   });

  //   // Set the updated productEntries array to state
  //   setProductEntries(newArray);
  // };

  const handleInputChange = (id, field, value) => {
    setProductEntries((prev) =>
      prev.map((item) => (item.id === id ? { ...item, [field]: value } : item))
    );
  };

  return (
    <div className="productsContainer rounded py-2  ">
      <div className="flex justify-between items-center mb-2">
        <h3 className="text-gray-700 font-medium ">Tasks</h3>
        <div className="flex gap-2">
          <button
            onClick={(e) => handleAddRow(e)}
            className="flex items-center gap-1 px-3 py-1.5 bg-green-600 hover:bg-green-700 text-white text-sm rounded shadow transition"
          >
            <AiOutlinePlus className="w-4 h-4" />
            Add
          </button>
        </div>
      </div>
      <div className="">
        {selectedRows?.length > 0 && (
          <button
            onClick={deleteSelectedRows}
            disabled={selectedRows?.length === 0}
            className="px-3 py-1 bg-red-500 text-white rounded hover:bg-red-600 mb-2"
          >
            Delete Selected
          </button>
        )}
        <table className="min-w-full bg-white border border-gray-300   ">
          <thead className="">
            <tr className="bg-gray-200  rounded">
              <th className="border px-2 py-1 text-center">
                <input
                  className="rounded border border-sm shadow"
                  type="checkbox"
                  onChange={toggleSelectAll}
                  checked={
                    selectedRows?.length === productEntries?.length &&
                    productEntries?.length > 0
                  }
                />
              </th>
              <th className="px-1 py-0.5 font-normal text-sm border">
                Task Sl No
              </th>
              <th className="px-1 py-0.5 font-normal text-sm w-[100px]  border">
                Task Group
              </th>
              <th className="px-1 py-0.5 font-normal text-sm w-[300px]  border">
                Task Description
              </th>
              {/* <th className="px-1 py-0.5 font-normal text-sm   border">
                Action
              </th> */}
            </tr>
          </thead>

          <tbody>
            {productEntries?.map((row, index) => (
              <tr key={index} className="text-lg">
                {console.log(
                  "productEntries in tabel: currentProductEntryRowId",
                  productEntries,
                  currentProductEntryRowId
                )}

                <td className=" border w-[20px]  text-center">
                  <input
                    type="checkbox"
                    className="rounded border border-sm shadow"
                    checked={selectedRows.includes(index)}
                    onChange={() => toggleRowSelection(index)}
                  />
                </td>

                <td className=" border  w-[10px] text-center ">
                  <input
                    type="text"
                    ref={(el) => {
                      if (el) newSlNoRef.current[row.id] = el;
                    }}
                    id={row?.id}
                    value={row?.Task_Serial || ""}
                    onChange={(e) =>
                      handleInputChange(row.id, "Task_Serial", e.target.value)
                    }
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        if (taskDescRefs.current) {
                          taskDescRefs.current.focus();
                        }
                      }
                    }}
                    className="w-full p-1 border-none text-sm font-thin focus:outline-none focus:ring-0 text-left"
                  />
                </td>
                <td className=" border ">
                    <input
                      type="text"
                      ref={(el) => {
                        if (el) taskGroupRefs.current[row.id] = el;
                      }}
                      id={row?.id}
                      value={row?.task_group}
                      onChange={(e) =>
                        handleInputChange(
                          row.id,
                          "task_group",
                          e.target.value
                        )
                      }
                      onKeyDown={(e) => {
                        // e.preventDefault();
                        if (e.key === "Enter") {
                          // setTimeout((e) => {
                          handleAddRow();
                          // newSlNoRef.current.focus()
                          // }, 0);
                        }
                      }}
                      className="w-full p-1 border-none text-sm font-thin focus:outline-none focus:ring-0 text-left"
                    />
                  </td>
                <Tooltip title={row?.Task_Description} arrow>
                  <td className=" border ">
                    <input
                      type="text"
                      ref={(el) => {
                        if (el) taskDescRefs.current[row.id] = el;
                      }}
                      id={row?.id}
                      value={row?.Task_Description}
                      onChange={(e) =>
                        handleInputChange(
                          row.id,
                          "Task_Description",
                          e.target.value
                        )
                      }
                      onKeyDown={(e) => {
                        // e.preventDefault();
                      if (e.key === "Enter") {
                        e.preventDefault();
                        if (taskGroupRefs.current) {
                          taskGroupRefs.current.focus();
                        }
                      }
                      }}
                      className="w-full p-1 border-none text-sm font-thin focus:outline-none focus:ring-0 text-left"
                    />
                  </td>
                </Tooltip>
                  

                {/* <td className=" border w-[20px]  text-center">
<button
  onClick={() => openAssign(row?.Task_Serial)}
  className={`px-2 py-1 rounded text-sm font-medium ${
    assignedTaskSerialsMap[row?.Task_Serial]
      ? "bg-blue-500 hover:bg-blue-600 text-white"
      : "bg-gray-400 hover:bg-gray-500 text-white"
  }`}
>
  {assignedTaskSerialsMap[row?.Task_Serial] ? "Assigned" : "Unassigned"}
</button>
                </td> */}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {openAssignModel && (
        <div className="fixed bg-black bg-opacity-50 inset-0 flex justify-center items-center z-50">
          <div className="relative w-full max-w-2xl bg-white rounded-2xl overflow-y-scroll hover:scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent p-1   max-h-[50vh]">
            <AssignJobModalEntryForm
              onAssign={handleAssignPerson}
              onClose={closeAssignModal}
              taskSerial={taskSerialToBeAassigned}
              assignButtonLabel={handleAssignButtonLabel}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default OfficeJobsGrid;
